import { ROUTES } from '@/router';

export const ROUTES_WITH_EMPTY_HEADER = [
  ROUTES.Public.WebToLeadForm,
  ROUTES.Public.TEMPORARY_SFDC_DEV,
  ROUTES.Public.TEMPORARY_SFDC_QA,
  ROUTES.Public.TEMPORARY_SFDC_STG,
  ...Object.values(ROUTES.System),
  ...Object.values(ROUTES.Auth),
];
